import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/apiClient";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldAlert } from "lucide-react";
import { toast } from "sonner";

export default function ForcedPasswordChange() {
  const { checkAuth, logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error("A nova senha deve ter pelo menos 6 caracteres."); return; }
    if (next !== confirm) { toast.error("As senhas não conferem."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Senha definida com sucesso!");
      await checkAuth();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50" data-testid="forced-password-screen">
      <Card className="w-full max-w-md border-slate-200 shadow-sm">
        <CardContent className="p-8">
          <div className="flex items-center justify-center mb-4">
            <img src="/logo-clima-branca.png" alt="Clima Branca Franquias" className="h-12" />
          </div>
          <div className="flex items-start gap-2 rounded-lg bg-amber-50 border border-amber-100 p-3 mb-5">
            <ShieldAlert className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-amber-800">
              Por segurança, defina uma nova senha antes de continuar. Sua senha atual é provisória.
            </p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="cur">Senha provisória (atual)</Label>
              <Input id="cur" type="password" required value={current}
                onChange={(e) => setCurrent(e.target.value)} data-testid="forced-current-input" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="new">Nova senha</Label>
              <Input id="new" type="password" required value={next}
                onChange={(e) => setNext(e.target.value)} placeholder="Mínimo 6 caracteres" data-testid="forced-new-input" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="conf">Confirmar nova senha</Label>
              <Input id="conf" type="password" required value={confirm}
                onChange={(e) => setConfirm(e.target.value)} data-testid="forced-confirm-input" />
            </div>
            <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700" disabled={busy} data-testid="forced-submit-button">
              {busy ? "Salvando..." : "Definir nova senha"}
            </Button>
            <button type="button" onClick={logout} className="w-full text-sm text-slate-400 hover:text-slate-600" data-testid="forced-logout">
              Sair
            </button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
